import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';

export interface PaygCandidate {

  probateId: number;

  bequestId: number;

  beneficiaryId: number;

  beneficiaryName: string;

  beneficiaryURN: string;

  email?: string;

  bequestType?: string;

  estateValue?: number;

  bequestValue?: number;

  verificationDate?: string;

  subscribed?: boolean;

  sendEmail: boolean;

  issueDate?: string;

}

export interface SendPaygEmailsRequest {

  subject: string;

  body: string;

  bequestIds: number[];

}


@Component({
  selector: 'app-admin-payg-email-dialog',
  templateUrl: './admin-payg-email-dialog.component.html',
  styleUrl: './admin-payg-email-dialog.component.css',
  standalone: false
})
export class AdminPaygEmailDialogComponent implements OnInit {

  selectedRecipients: PaygCandidate[] = [];

  subject = "";

  body = `Dear [BENEFICIARY_NAME],

We are contacting you regarding your legacy information.

Your URN is [URN].

Kind regards,

Charity Central`;


  previewSubject = "";

  previewBody = "";

  constructor(
    public dialogRef: MatDialogRef<AdminPaygEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaygCandidate[]
  ) { }

  ngOnInit(): void {

    this.selectedRecipients = this.data ?? [];



    this.updatePreview();

  }

  insertVariable(variable: string): void {

    this.body += variable;

    this.updatePreview();

  }

 updatePreview(): void {

  if (this.selectedRecipients.length === 0) {

    this.previewSubject = this.subject;
    this.previewBody = this.body;

    return;

  }

  const recipient = this.selectedRecipients[0];

  this.previewSubject = this.replaceVariables(
    this.subject,
    recipient
  );

  this.previewBody = this.replaceVariables(
    this.body,
    recipient
  );

}

  sendEmails(): void {

    this.dialogRef.close({
      subject: this.subject,
      body: this.body,
      bequestIds: this.selectedRecipients.map(x => x.bequestId)
    });

  }

  //sendPaygEmails(request: SendPaygEmailsRequest) {

  //  return this.http.post(
  //    `${environment.apiUrl}/Admin/SendPaygEmails`,
  //    request
  //  );

  //}

  private replaceVariables(
    text: string,
    recipient: PaygCandidate
  ): string {

    if (!text) {
      return "";
    }

    return text

      .replaceAll("[BENEFICIARY_NAME]", recipient.beneficiaryName ?? "")

      .replaceAll("[URN]", recipient.beneficiaryURN ?? "")

      .replaceAll("[EMAIL]", recipient.email ?? "")

      .replaceAll("[PROBATE_ID]", recipient.probateId?.toString() ?? "")

      .replaceAll("[BEQUEST_TYPE]", recipient.bequestType ?? "")

      .replaceAll(
        "[ESTATE_VALUE]",
        recipient.estateValue != null
          ? recipient.estateValue.toLocaleString("en-GB", {
            style: "currency",
            currency: "GBP",
            maximumFractionDigits: 0
          })
          : ""
      )

      .replaceAll(
        "[BEQUEST_VALUE]",
        recipient.bequestValue != null
          ? recipient.bequestValue.toLocaleString("en-GB", {
            style: "currency",
            currency: "GBP",
            maximumFractionDigits: 0
          })
          : ""
      )

      .replaceAll(
        "[ISSUE_DATE]",
        recipient.issueDate ?? ""
      )

      .replaceAll(
        "[VERIFICATION_DATE]",
        recipient.verificationDate ?? ""
      );

  }

}
